import { render, staticRenderFns } from "./mailingList1.vue?vue&type=template&id=93b77998&scoped=true&"
import script from "./mailingList1.vue?vue&type=script&lang=js&"
export * from "./mailingList1.vue?vue&type=script&lang=js&"
import style0 from "./mailingList1.vue?vue&type=style&index=0&id=93b77998&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b77998",
  null
  
)

export default component.exports